import { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Fade } from "react-awesome-reveal";

// Images
import innerCover from "assets/images/banners/infra.webp";
import infra from "assets/images/infra-gate.webp";
import infra1 from "assets/images/infra-1.webp";
import infra2 from "assets/images/infra-2.webp";
import infra3 from "assets/images/infra-3.webp";
import infra4 from "assets/images/infra-4.webp";
import infra5 from "assets/images/infra-5.webp";
import infra6 from "assets/images/infra-6.webp";
import infra7 from "assets/images/infra-7.webp";
import infra8 from "assets/images/infra-8.webp";
import infra9 from "assets/images/infra-9.webp";
import infra10 from "assets/images/infra-10.webp";
import infra11 from "assets/images/infra-11.webp";
import infra12 from "assets/images/infra-12.webp";
import infra13 from "assets/images/infra-13.webp";
import infra14 from "assets/images/infra-14.webp";
import infra15 from "assets/images/infra-15.webp";
import infra16 from "assets/images/infra-16.webp";
import infra17 from "assets/images/infra-17.webp";
import infra18 from "assets/images/infra-18.webp";
import infra19 from "assets/images/infra-19.webp";
import infra20 from "assets/images/infra-20.webp";
import infra21 from "assets/images/infra-21.webp";
import infra22 from "assets/images/infra-22.webp";
import infra23 from "assets/images/infra-23.webp";
import infra24 from "assets/images/infra-24.webp";
import infra25 from "assets/images/infra-25.webp";
import infra26 from "assets/images/infra-26.webp";
import infra27 from "assets/images/infra-27.webp";
import infra28 from "assets/images/infra-28.webp";

const images = [
  infra,
  infra1,
  infra2,
  infra3,
  infra4,
  infra5,
  infra6,
  infra7,
  infra8,
  infra9,
  infra10,
  infra11,
  infra12,
  infra13,
  infra14,
  infra15,
  infra16,
  infra17,
  infra18,
  infra19,
  infra20,
  infra21,
  infra22,
  infra23,
  infra24,
  infra25,
  infra26,
  infra27,
  infra28,
];

function Infrastructure() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <>
      <MKBox
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${innerCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
        className="innerCover"
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: { fontSize: size["3xl"] },
              })}
            >
              Infrastructure
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>

      <Card
        sx={{
          p: { xs: 4, lg: 8 },
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <div className="content">
          <MKTypography variant="subtitle1" className="text-j" mt={4} mb={4}>
            <Fade>
              Sree Narayana Law College, Poothotta has some of the excellent infrastructure
              facilities available for legal education. Its strategic location is another positive
              which makes accessibility easy. The college is now housed in the new building having
              four floors including the ground floor. The building contains enough number of class
              rooms, Separate Moot Court Room, Legal Aid Clinic, National Service Scheme Unit, Human
              Rights Cell, Women empowerment Cell. Apart from these, spacious room office staff,
              Principal, teaching staff and guest room. Sufficient number of separate toilet
              facility for girls and boy students. The College has a good law library with
              sufficient number of books and enough space for arranging books. Separate area for
              reference books and for reading. Faculty reading area is also provided in the library.
              Free internet facility provided for e-learning for teachers and students. The college
              is differently-abled friendly access and Lift facility in all the floor. The entire
              building is protected against fire. Satisfied all norms of fire and safety. The entire
              building is protected under the rules and regulations of fire and safety.
            </Fade>
          </MKTypography>
          <Grid container spacing={2}>
            {images.map((src, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Fade triggerOnce direction="up" cascade damping={0.1} duration={600}>
                  <div
                    onClick={() => openLightbox(index)}
                    style={{
                      cursor: "pointer",
                      overflow: "hidden",
                      borderRadius: "8px",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <img
                      src={src}
                      loading="lazy"
                      alt={`Infra ${index + 1}`}
                      className="img-fluid"
                      style={{
                        width: "100%",
                        height: "auto",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                      onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    />
                  </div>
                </Fade>
              </Grid>
            ))}
          </Grid>
        </div>
      </Card>

      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </>
  );
}

export default Infrastructure;
